export const blockIconsMapsFastfoodNew = (
	<span className='material-symbols-outlined'>fastfood</span>
);
